/**
 * The authentication methods we support through our UI.
 * Currently we support `emailMagicLinks`, `emailOtp`, `sso`, `passwords`, and `oauth`.
 */ const AuthFlowType = {
    Discovery: 'Discovery',
    Organization: 'Organization',
    PasswordReset: 'PasswordReset'
};
const RedirectURLType = {
    ResetPassword: 'reset_password'
};
/**
 * The OAuth providers we support in our B2B OAuth product.
 */ const B2BOAuthProviders = {
    Google: 'google',
    Microsoft: 'microsoft',
    HubSpot: 'hubspot',
    Slack: 'slack',
    GitHub: 'github'
};
const B2BMFAProducts = {
    smsOtp: 'smsOtp',
    totp: 'totp'
};

export { AuthFlowType, B2BMFAProducts, B2BOAuthProviders, RedirectURLType };
//# sourceMappingURL=ui.mjs.map
